const {OutputConfiguration} = require("./configuration/output-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");

const OutputStepTabs = {
    configuration: OutputConfiguration,
    preview: PreviewTab,
};
exports.OutputStepTabs = OutputStepTabs;
